/**
 * ButtonSpinner
 * =============
 *
 * A small inline SVG spinner sized for use inside buttons.  Matches the
 * spinner pattern used throughout the rest of the app (circle track with a
 * quarter-arc indicator, using `animate-spin`).
 *
 * Renders as an inline-flex element so it flows naturally alongside button
 * text.  The colour inherits from the parent via `currentColor`, so it
 * automatically adapts to both white-on-coloured and dark-on-light buttons.
 */

import React from 'react';

/**
 * @param {Object} props
 * @param {string} [props.className] – Extra classes to merge (e.g. custom sizing)
 */
export default function ButtonSpinner({ className = 'h-4 w-4' }) {
  return (
    <svg
      className={`animate-spin ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
